;!function(){try{var e="undefined"!=typeof window?window:"undefined"!=typeof global?global:"undefined"!=typeof globalThis?globalThis:"undefined"!=typeof self?self:{};e._sentryModuleMetadata=e._sentryModuleMetadata||{},e._sentryModuleMetadata[(new e.Error).stack]=Object.assign({},e._sentryModuleMetadata[(new e.Error).stack],{"_sentryBundlerPluginAppKey:qogita-web-sellers":true});}catch(e){}}();import clsx from 'clsx'

type TopBarAccountButtonGreetingProps = {
  name?: string
  greeting: string
  linkText: string
  className?: string
}

export const TopBarAccountButtonGreeting = ({
  name,
  greeting,
  linkText,
  className,
}: TopBarAccountButtonGreetingProps) => {
  const greetingText = name ? `${greeting}, ${name}` : greeting

  return (
    <div className={clsx('flex flex-col gap-0.5 overflow-hidden', className)}>
      <p className="max-w-[12rem] truncate text-xs">{greetingText}</p>

      <p className="text-xs font-bold">{linkText}</p>
    </div>
  )
}
